<div class="container">
  <h1 mat-dialog-title class="dialog-title">Alterar o BP</h1>
  <div mat-dialog-content>
    <form [formGroup]="form">
      <div>
        <label>Alterar De:</label>
        <input class="input_bp" type="text" name="myBp"
          placeholder="Exemplo: 00123456"
          required formControlName="from">
          @if (!form.controls.from.valid && confirmed) {
            <app-error-form>
              Informe o BP do seu usuário.
            </app-error-form>
          }
        </div>

        <div class="container-new-bp">
          <label>Para:</label>
          <input class="input_bp" type="text" name="newBp"
            placeholder="Exemplo: 00654321"
            required formControlName="to">
            @if (!form.controls.to.valid && confirmed) {
              <app-error-form>
                Informe o BP que deseja definir para o seu usuário.
              </app-error-form>
            }
          </div>
        </form>
      </div>
      <div mat-dialog-actions class="dialog-actions">
        <button class="btn btn-close" mat-dialog-close>Cancelar</button>
        <button class="btn btn-ok" mat-button (click)="confirm();">Alterar</button>
      </div>
    </div>


